import getAPIPath from '../modules/api-location';

window.isFavouriteService = function(contentId, modelType, successFn) {
  return $.ajax({
    url: `${getAPIPath}queryapi/is-favourite?content_id=${contentId}&model_type=${modelType}`,
    type: `get`,
    success: successFn,
    async: true,
    xhrFields: {
      withCredentials: true,
    },
  });
};

let getParams = ``;
function constructFollowGetParam(item) {
  getParams = `${getParams}user_id=${item}&`;
}

window.doIFollowService = function(userIds, successFn) {
  userIds.forEach(constructFollowGetParam);

  return $.ajax({
    url: `${getAPIPath}queryapi/do-i-follow?${getParams}`,
    type: `get`,
    success: successFn,
    async: true,
    xhrFields: {
      withCredentials: true,
    },
  });
};

window.myFoldersService = function(successFn) {
  return $.ajax({
    url: `${getAPIPath}queryapi/my-folders`,
    type: `get`,
    success: successFn,
    async: true,
    xhrFields: {
      withCredentials: true,
    },
  });
};



// WEBPACK FOOTER //
// ./library/js/services/content.service.js